module.exports = __webpack_public_path__ + "static/media/modamilyText.bfea2904.png";